/**
 * The constants in this file identify the types of content
 * that the JsonView needs to be able to display.
 */

// A wrapper for the entire code block.
export const CODE = 'CODE'

// A wrapper for a line of code.
export const LINE = 'LINE'

// A wrapper for a highlighted line of code.
export const HIGHLIGHTED_LINE = 'HIGHLIGHTED_LINE'

// "myString"
export const STRING_VALUE = 'STRING_VALUE'

// 1234
export const NUMBER_VALUE = 'NUMBER_VALUE'

// true
export const BOOLEAN_VALUE = 'BOOLEAN_VALUE'

// null
export const NULL_VALUE = 'NULL_VALUE'

// "myProperty"
export const PROPERTY_NAME = 'PROPERTY_NAME'

// 1
// 2
// 3
export const LINE_NUMBER = 'LINE_NUMBER'
